module.exports = __webpack_public_path__ + "static/media/filter.e5cafd30.svg";